import { useStore, useStoreActions } from '~/contexts';
import { selectors } from '~/store/state-selectors';
import { useMutationState } from '../useMutationState';
import { useSaveCustomPageText } from './useSaveCustomPageText';
export const useCloneCustomPageText = ()=>{
    const { api } = useStoreActions();
    const businessId = useStore(selectors.user.businessId);
    const { saveText } = useSaveCustomPageText();
    const { mutateAsync, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { sourceTextId } = param;
            if (businessId == null) throw new Error('businessId is required');
            const { content } = await api.customPage.getText(businessId, sourceTextId);
            return saveText({
                businessId,
                content
            });
        }
    });
    return {
        cloneText: mutateAsync,
        isCloning: isLoading
    };
};
